import { Parser } from "@siteimprove/alfa-parser";
import { Token } from "./token.js";
const { option, delimited } = Parser;
/**
 * @public
 */
export var Comma;
(function (Comma) {
    /**
     * @remarks
     * In CSS, commas can often be preceded or followed by whitespace.
     */
    Comma.parse = delimited(option(Token.parseWhitespace), Token.parseComma);
})(Comma || (Comma = {}));
//# sourceMappingURL=comma.js.map